import { registerNotification } from './registry'

registerNotification('review:assigned', {
  icon: () => 'question',
})